/**
 * Public Survey Response Page — IG-7
 *
 * Member-side page reached via the IG-6 distribution link:
 *   {FRONTEND_URL}/surveys/{survey_id}?member_id=...
 *
 * Unauthenticated by design — possession of the link is the access grant.
 * The load/render/submit logic lives in the shared SurveyFill component (also
 * embedded inside the LMS course players); this page just supplies the
 * member_id from the query string.
 */
import React, { useMemo } from 'react';
import { SurveyFill } from './SurveyFill';

interface Props {
  surveyId: string;
}

export const PublicSurveyPage: React.FC<Props> = ({ surveyId }) => {
  const memberId = useMemo(() => {
    if (typeof window === 'undefined') return null;
    return new URLSearchParams(window.location.search).get('member_id');
  }, []);

  return <SurveyFill surveyId={surveyId} memberId={memberId} />;
};

export default PublicSurveyPage;
